import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = 'Bearer ' + token;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (d) => api.post('/auth/register', d),
  login:    (d) => api.post('/auth/login', d),
  me:       ()  => api.get('/auth/me'),
};

export const accountsAPI = {
  list:   ()       => api.get('/accounts'),
  create: (d)      => api.post('/accounts', d),
  update: (id, d)  => api.put('/accounts/' + id, d),
  delete: (id)     => api.delete('/accounts/' + id),
};

export const transactionsAPI = {
  recategorizeUniversal: (data) => api.post('/transactions/recategorize-universal', data),
  list:   (params)     => api.get('/transactions', { params }),
  create: (d)          => api.post('/transactions', d),
  update: (id, d)      => api.put('/transactions/' + id, d),
  delete: (id)         => api.delete('/transactions/' + id),
  deleteAll:           () => api.delete('/transactions/all'),
  batchDelete: (ids)   => api.post('/transactions/batch-delete', ids),
  batchRestore: (items)=> api.post('/transactions/batch-restore', items),
  recategorize:        () => api.post('/transactions/recategorize'),
  importCSV: (accountId, file, force = false) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post(
      '/transactions/import-csv?account_id=' + accountId + '&force=' + force,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },
};

export const summaryAPI = {
  overview:        (params) => api.get('/summary/overview', { params }),
  byCategory:      (params) => api.get('/summary/by-category', { params }),
  reimbursements:  ()       => api.get('/summary/reimbursements'),
  // Accepts either a number (months) or an object { months } / { from_date }
  monthly: (paramsOrMonths) => {
    const params = typeof paramsOrMonths === 'number'
      ? { months: paramsOrMonths }
      : (paramsOrMonths || { months: 6 });
    return api.get('/summary/monthly', { params });
  },
};

export const reportsAPI = {
  spendingByCategory: (params) => api.get('/reports/spending-by-category', { params }),
  monthlyTotals:      (params) => api.get('/reports/monthly-totals',        { params }),
  reportSummary:      (params) => api.get('/reports/summary',               { params }),
  csv:      (params) => api.get('/reports/csv',      { params, responseType: 'blob' }),
  markdown: (params) => api.get('/reports/markdown', { params, responseType: 'blob' }),
};

export const forecastAPI = {
  calculate:      (p)    => api.post('/forecast/calculate', p),
  scenarios:      ()     => api.get('/forecast/scenarios'),
  createScenario: (d)    => api.post('/forecast/scenarios', d),
  deleteScenario: (id)   => api.delete('/forecast/scenarios/' + id),
};

export const rulesAPI = {
  list:   ()                    => api.get('/rules'),
  add:    (d)                   => api.post('/rules', d),
  delete: (pattern, category)   => api.delete('/rules', { params: { pattern, category } }),
};

export default api;
